export default "__VITE_ASSET__33577622__"